module.exports = __webpack_public_path__ + "img/UserVoice.448b00d1.svg";